import styled from 'styled-components';
import { DeprecatedText } from '../DeprecatedText';
export const Wrap = styled.div ``;
export const Content = styled(DeprecatedText) `
  display: inline;
  margin-right: 5px;
`;
export const StyledButton = styled.button `
  background: transparent;
  border: none;
  cursor: pointer;
  display: inline-block;
  font-weight: 700;
  height: auto;
  padding: 0;
  text-decoration: underline;

  &:focus {
    outline: 0 none transparent;
  }

  &:hover {
    text-decoration: none;
  }
`;
//# sourceMappingURL=styles.js.map